import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function NeyPlayer(props: InstrumentPlayerProps) {
  const isPersian = props.variant.id === "persian_ney";

  return (
    <div className="instrument-ui ney-ui" data-testid="instrument-player-ney">
      <div className="ney-tube" aria-label="End-blown vertical reed flute">
        <span className="ney-end">end-blown</span>
        {Array.from({ length: 6 }, (_, index) => (
          <button key={index} type="button" className="ney-hole" aria-label={`Play ney hole ${index + 1}`} onClick={() => triggerMomentary(props, noteForIndex(props.instrument.playableNotes, index), "ney_hole", 0.66, 520)} />
        ))}
      </div>
      <div className="instrument-control-strip">
        <label className="surface-slider" data-control-target="ney-breath"><span>Breath</span><input aria-label="Ney breath pressure" type="range" min="0" max="1" step="0.01" defaultValue="0.55" onInput={(event) => props.onControl("breath_pressure", Number(event.currentTarget.value))} /></label>
        <label className="surface-slider"><span>Microbend</span><input aria-label="Ney microbend slider" type="range" min="0" max="1" step="0.01" defaultValue="0.35" onInput={(event) => props.onControl("ney_microbend", Number(event.currentTarget.value))} /></label>
        <button type="button" aria-label="Trigger ney overblow register" data-control-target="ney-overblow" onClick={() => triggerMomentary(props, "C5", "overblow", 0.72, 420)}>Overblow</button>
        <button type="button" aria-label="Trigger ney micro bend" onClick={() => triggerMomentary(props, "D4", "micro_bend", 0.68, 420)}>Micro bend</button>
        <button type="button" aria-label="Trigger ney grace note" onClick={() => triggerMomentary(props, "E4", "grace_note", 0.66, 180)}>Grace note</button>
      </div>
      {isPersian ? <p className="instrument-note">Persian Ney: interdental embouchure and brighter upper harmonic profile.</p> : null}
    </div>
  );
}
